import * as yup from 'yup'

export const schemaPermissionByOption = yup.object().shape({
  opcion: yup.string().required('El nombre es obligatorio'),
  codigo: yup.string().required('El código es obligatorio'),
})
export const schemaOptionByProfile = yup.object().shape({
  vistaPermisoId: yup.string().required('La vista es obligatorio'),
})
export const schemaProfileByUser = yup.object().shape({
  aplicacionId: yup.string().required('El módulo es obligatorio'),
  perfilId: yup.string().required('El perfil es obligatorio'),
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
})
export const schemaCECO = yup.object().shape({
  area_Proyecto: yup.string().required('El área de proyecto es obligatorio'),
  centrodecosto: yup.string().required('El centro de costo es obligatorio'),
})
export const schemaEmailTemplate = yup.object().shape({
  aplicacionId: yup.string().required('El módulo es obligatorio'),
  envioCustomizado: yup.string().required('El envío customizado es obligatorio'),
  nombre: yup.string().required('El nombre email es obligatorio'),
  de: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `El de es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
  para: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `El para es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
  mensaje: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `El mensaje es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
  asunto: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `El asunto es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
  tabla: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `La tabla es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
  idColumna: yup.string().test({
    name: 'dynamicValidation',
    message: 'Cantidad de carácteres no validos',
    test: async function (texto) {
      const envioCustomizado_ = this.parent.envioCustomizado
      if (!texto && envioCustomizado_ === 'NO') {
        return this.createError({
          message: `El id Columna es obligatorio.`, // Modifica el mensaje de error
          path: this.path,
        })
      }
      return true
    },
  }),
})

export const schemaClaim = yup.object().shape({
  CompaniaId: yup.string().required('La compañía es obligatorio'),
  ClienteId: yup.string().required('El cliente es obligatorio'),
  SiteId: yup.string().required('El site es obligatorio'),
  CampamentoId: yup.string().required('El campamento es obligatorio'),
  TipoRequerimientoId: yup.string().required('El tipo de requerimiento es obligatorio'),
  AplicacionId: yup.string().required('El módulo es obligatorio'),
  FechaRequerimiento: yup.string().required('La fecha de reclamo es obligatorio'),
  ReclamanteId: yup.string().required('El reclamante es obligatorio'),
  Reclamo: yup.string().required('El reclamo es requerido'),
  HuespedId: yup.string().when('ReclamanteId', {
    is: '+BPMQ4keWgI=',
    then: yup.string().required('Los datos del reclamante son obligatorios'),
    otherwise: yup.string().notRequired(),
  }),
  ColaboradorId: yup.string().when('ReclamanteId', {
    is: '+BPMQ4keWgI=',
    then: yup.string().notRequired(),
    otherwise: yup.string().required('Los datos del reclamante son obligatorios'),
  }),
})
export const schemaClaimUser = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  tipoRequerimientoId: yup.string().required('El tipo de requerimiento es obligatorio'),
  aplicacionId: yup.string().required('El módulo es obligatorio'),
  fechaRequerimiento: yup.string().required('La fecha de reclamo es obligatorio'),
  reclamo: yup.string().required('El reclamo es requerido'),
})

export const schemaParameter = yup.object().shape({
  CompaniaId: yup.string().required('La compañía es obligatorio'),
  ClienteId: yup.string().required('El cliente es obligatorio'),
  SiteId: yup.string().required('El site es obligatorio'),
  CampamentoId: yup.string().required('El capamento es obligatorio'),
  AplicacionId: yup.string().required('El módulo es obligatorio'),
  ValorizacionId: yup.string().required('El tipo de valorización es obligatorio'),
  MonedaId: yup.string().required('La moneda es obligatorio'),
  UnidadParametrosId: yup.string().required('La unidad es obligatorio'),
  FechaIni: yup.string().required('La fecha de inicio es obligatorio'),
  FechaFin: yup.string().required('La fecha de fin es obligatorio'),
  HoraCorte: yup.string().when('AplicacionId', {
    is: '2fd7RKUf0X8=',
    then: yup.string().required('La hora de corte es obligatoria'),
  }),

  TipoEstadiaId: yup.string().when('AplicacionId', {
    is: '2fd7RKUf0X8=',
    then: yup.string().required('El tipo de estadía es obligatorio'),
  }),
})

export const schemaRangeParameter = yup.object().shape({
  CompaniaId: yup.string().required('La compañía es obligatorio'),
  ClienteId: yup.string().required('El cliente es obligatorio'),
  SiteId: yup.string().required('El site es obligatorio'),
  CampamentoId: yup.string().required('El capamento es obligatorio'),
  AplicacionId: yup.string().required('El módulo es obligatorio'),
})

export const schemaCategory = yup.object().shape({
  codigo: yup.string().required('El código es obligatorio'),
  nombre: yup.string().required('El nombre es obligatorio'),
})

export const schemaParams = yup.object().shape({
  tabla: yup.string().required('La categoría es obligatorio'),
  codigo: yup.string().required('El código es obligatorio'),
  nombreCorto: yup.string().required('El nombre corto es obligatorio'),
  nombreLargo: yup.string().required('El nombre largo es obligatorio'),
  tipoDato: yup.string().required('El tipo de dato es obligatorio'),
  estado: yup.string().required('El estado es obligatorio'),
})

export const schemaExportData = yup.object().shape({
  nombreAplicacion: yup.string().required('El módulo es obligatorio'),
  nombreTabla: yup.string().required('La tabla es obligatorio'),
})
export const schemaExportFormData = yup.object().shape({
  isCompany: yup.string(),
  companiaId: yup.string().when('isCompany', {
    is: (isCompany) => isCompany === 'SI',
    then: yup.string().required('La compañía es obligatorio'),
    otherwise: yup.string(),
  }),
  isClient: yup.string(),
  clienteId: yup.string().when('isClient', {
    is: (isClient) => isClient === 'SI',
    then: yup.string().required('El cliente es obligatorio'),
    otherwise: yup.string(),
  }),
  isSite: yup.string(),
  siteId: yup.string().when('isSite', {
    is: (isSite) => isSite === 'SI',
    then: yup.string().required('El site es obligatorio'),
    otherwise: yup.string(),
  }),
  fechaInicio: yup.string().required('El módulo es obligatorio'),
  fechaFin: yup.string().required('La tabla es obligatorio'),
})
